/**
 * Warstwa API: REAKCJE POD WIADOMOŚCIAMI CZATU TEAMS (S20, 2026-09-14).
 *
 * Trasy backendu (TeamsChatController): `POST api/teams-chat/chats/{chatId}/messages/{messageId}/reactions`
 * z ciałem `{ reactionType }` i `DELETE …/reactions?reactionType=`. Backend woła Graph setReaction/unsetReaction
 * tokenem delegowanym zalogowanego; reakcja spoza białej listy (nazwa Teams albo pojedynczy znak emoji) → 400.
 *
 * Zdejmując reakcję, podaj DOKŁADNY zapis z `myReactionType` (starsze „like” i znak „👍” to w Teams dwa różne zapisy).
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js (interceptor JWT, obsługa 401) i zwraca obiekt
 * nazwanych metod doczepianych do wspólnego `apiService`. Nazwy muszą być unikalne w całej aplikacji — kolizja
 * zatrzymuje start (patrz attachApiModules). apiService.js jest ZAMKNIĘTY dla nowych metod.
 */
const sciezkaReakcji = (chatId, messageId) =>
    `/teams-chat/chats/${encodeURIComponent(chatId)}/messages/${encodeURIComponent(messageId)}/reactions`;

export function attach(api) {
    return {
        /** Dodaje reakcję (np. „👍”) do wiadomości w rozmowie Teams. */
        setTeamsMessageReaction: (chatId, messageId, reactionType) =>
            api.post(sciezkaReakcji(chatId, messageId), { reactionType }),

        /** Zdejmuje własną reakcję — `reactionType` = `myReactionType` z pozycji reakcji. */
        unsetTeamsMessageReaction: (chatId, messageId, reactionType) =>
            api.delete(sciezkaReakcji(chatId, messageId), { params: { reactionType } }),
    };
}
